export const ApiAuth = {
    login: data => ({
        url: '/auth/local',
        method: 'POST',
        data
    }),
    forgotPasswordManager: data => ({
        url: '/auth/forgotPasswordManager',
        method: 'POST',
        data
    }),
    registerManager: data => ({
        url: '/auth/local/registerManager',
        method: 'POST',
        data
    }),
    emailConfirmation: confirmation => ({
        url: `/auth/email-confirmation?confirmation=${confirmation}`,
        method: 'GET'
    }),
    resetPassword: (code, data) => ({
        url: `/auth/reset-password`,
        method: 'POST',
        data: {
            code,
            ...data
        }
    })
};